import React, { FC, ReactNode, useState } from 'react';

import { Box, IconButton, ClickAwayListener } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import cx from 'classnames';

import useStyles from './styles';

interface TableRowWithActionsProps {
  actionsList?: ReactNode;
  children?: ReactNode;
  wrapperClass?: string;
  cellsClass?: string;
  width: Breakpoint;
}

const TableRowWithActions: FC<TableRowWithActionsProps> = ({
  actionsList,
  children,
  wrapperClass = '',
  cellsClass = '',
  width,
  ...rest
}) => {
  const classes = useStyles();
  const isMobile = !isWidthUp('md', width);

  const [isOpened, setIsOpened] = useState<boolean>(false);

  const handleClickMobile = () => {
    if (!isMobile || !actionsList) return;
    setIsOpened((prev) => !prev);
  };

  const handleDesktopClick = () => {
    if (isMobile || !actionsList) return;
    setIsOpened((prev) => !prev);
  };

  return (
    <ClickAwayListener onClickAway={() => setIsOpened(false)}>
      <Box data-testid={rest['data-testid']} className={cx(classes.tableRowWrap, wrapperClass)}>
        <Box className={classes.tableRow} onClick={handleClickMobile}>
          <Box className={cx(classes.tableCells, cellsClass)}>{children}</Box>
          {!isMobile && !!actionsList && (
            <IconButton
              className={classes.dotsBtn}
              aria-label="dropdown"
              onClick={handleDesktopClick}
            >
              <MoreHorizIcon />
            </IconButton>
          )}
        </Box>
        {!!actionsList && (
          <Box className={cx(classes.dropdown, isOpened && classes.dropdownOpened)}>
            <Box className={cx(isMobile ? '' : classes.dropdownContent)}>
              <ul className={classes.dropdownList}>{actionsList}</ul>
            </Box>
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default withWidth()(TableRowWithActions);
